import { render } from "./SelecaoDeDedo.vue?vue&type=template&id=7165b948&scoped=true"
import script from "./SelecaoDeDedo.vue?vue&type=script&lang=js"
export * from "./SelecaoDeDedo.vue?vue&type=script&lang=js"

import "./SelecaoDeDedo.vue?vue&type=style&index=0&id=7165b948&scoped=true&lang=css"

import exportComponent from "/woodpecker/src/github.com/Multpex/multpex.front.gestao/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7165b948"]])

export default __exports__